import * as React from "react";
const SvgTrailLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 2, viewBox: "0 0 2 34", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 30.0007L1 0L1 48", stroke: "#C5C6D0" }));
export default SvgTrailLine;
